/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * AcceptUserInviteResponseDtoBase
 * auto generated base class for the model AcceptUserInviteResponseDtoModel.
 */
export const AcceptUserInviteResponseDtoModelBase = ModelBase
  .named('AcceptUserInviteResponseDto')
  .props({
    __typename: types.optional(types.literal("AcceptUserInviteResponseDto"), "AcceptUserInviteResponseDto"),
    success: types.union(types.undefined, types.boolean),
    newOrganizationUuid: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class AcceptUserInviteResponseDtoModelSelector extends QueryBuilder {
  get success() { return this.__attr(`success`) }
  get newOrganizationUuid() { return this.__attr(`newOrganizationUuid`) }
}
export function selectFromAcceptUserInviteResponseDto() {
  return new AcceptUserInviteResponseDtoModelSelector()
}

export const acceptUserInviteResponseDtoModelPrimitives = selectFromAcceptUserInviteResponseDto().success.newOrganizationUuid
